<template>
  <FloatingIcons />
  <HomeNavbar />
  <main>
    <HomeBanner />
    <CompanyIntro />
    <!-- <HomeFeatures /> -->
    <ProductShowcase />
    <!-- <CallToAction /> -->
  </main>
  <HomeFooter />
</template>

<script setup>
import HomeNavbar from '@/components/HomeNavbar.vue'
import HomeBanner from '@/components/HomeBanner.vue'
import CompanyIntro from '@/components/CompanyIntro.vue'
// import HomeFeatures from '@/components/HomeFeatures.vue'
import ProductShowcase from '@/components/ProductShowcase.vue'
// import CallToAction from '@/components/CallToAction.vue'
import HomeFooter from '@/components/HomeFooter.vue'
import FloatingIcons from '@/components/FloatingIcons.vue'
</script>
